exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg { border-radius: 50%;\n}\n", ""]);

// exports
